import { Bus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { RECORRIDOS_ACTIVOS } from '@/data/recorridos/config';

const VARIANT = {
  primary: {
    active: 'bg-primary text-primary-foreground shadow-md border-transparent',
    idle: 'border-border/60 bg-card text-muted-foreground hover:bg-muted/50',
    iconActive: 'text-primary-foreground',
    iconIdle: 'text-primary',
  },
  orange: {
    active: 'bg-orange-500 text-white shadow-md border-transparent',
    idle: 'border-border/60 bg-card text-muted-foreground hover:bg-muted/50',
    iconActive: 'text-white',
    iconIdle: 'text-orange-600',
  },
  destructive: {
    active: 'bg-destructive text-destructive-foreground shadow-md border-transparent',
    idle: 'border-border/60 bg-card text-muted-foreground hover:bg-muted/50',
    iconActive: 'text-destructive-foreground',
    iconIdle: 'text-destructive',
  },
  secondary: {
    active: 'bg-secondary text-secondary-foreground shadow-md border-transparent',
    idle: 'border-border/60 bg-card text-muted-foreground hover:bg-muted/50',
    iconActive: 'text-secondary-foreground',
    iconIdle: 'text-secondary',
  },
  violet: {
    active: 'bg-violet-600 text-white shadow-md border-transparent',
    idle: 'border-border/60 bg-card text-muted-foreground hover:bg-muted/50',
    iconActive: 'text-white',
    iconIdle: 'text-violet-600',
  },
};

/**
 * @param {{ activeId: string; onSelect: (id: string) => void; recorridos?: typeof RECORRIDOS_ACTIVOS }} props
 */
export default function RecorridoRouteChips({ activeId, onSelect, recorridos: recorridosProp }) {
  const lista = recorridosProp ?? RECORRIDOS_ACTIVOS;
  return (
    <section className="relative -mx-4 overflow-hidden" aria-label="Selector de recorrido">
      <div className="no-scrollbar flex gap-2 overflow-x-auto px-4 pb-1 pt-0.5">
        {lista.map((r) => {
          const v = VARIANT[r.variant] || VARIANT.primary;
          const isActive = r.id === activeId;
          return (
            <button
              key={r.id}
              type="button"
              onClick={() => onSelect(r.id)}
              className={cn(
                'flex shrink-0 items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-bold transition-all active:scale-[0.97]',
                isActive ? v.active : v.idle
              )}
              data-testid={`recorrido-chip-${r.id}`}
              aria-pressed={isActive}
            >
              <Bus
                className={cn('h-4 w-4 shrink-0', isActive ? v.iconActive : v.iconIdle)}
                aria-hidden
              />
              <span className="font-headline tracking-tight">{r.codigo}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
